<div class="close-btn-outer">
  <button mat-mini-fab color="warn" (click)="close()"><mat-icon>close</mat-icon></button>
</div>
<div mat-dialog-content>
  <div class="mat-table discounts-table">
    <div class="mat-header-row">
      <div class="mat-header-cell"></div>
      <div class="mat-header-cell">Тип</div>
      <div class="mat-header-cell">Скидка</div>
      <div class="mat-header-cell">Описание</div>
      <div class="mat-header-cell text-right">Срок действия</div>
      <div class="mat-header-cell text-right">Выбрать</div>
    </div>
    <div *ngIf="appService.Data.discountCertificatesArray.length > 0">
      <div *ngFor="let discountCert of this.appService.Data.discountCertificatesArray" class="mat-row">
        <div class="mat-cell"><img *ngIf="discountCert.discountImageURL" [src]="discountCert.discountImageURL" class="discountImage" /></div>
        <div class="mat-cell"><span>Сертификат: </span><br /> <span class="discount">{{discountCert.certificateName}}</span></div>
        <div class="mat-cell">{{discountCert.discountPerc}}% на заказ</div>
        <div class="mat-cell text-left discountDescription">{{discountCert.description}}</div>
        <div class="mat-cell text-right">{{getProperCertificateEndDate(discountCert.endDate)}}</div>
        <div class="mat-header-cell text-right"><mat-checkbox [checked]="discountCert.isSelected" color="primary" (change)="handleDiscountCertificateSelection(discountCert.id)"></mat-checkbox></div>
      </div>
    </div>
    <div *ngFor="let discountCoupon of this.appService.Data.discountCouponsArray" class="mat-row">
      <div class="mat-cell"><img *ngIf="discountCoupon.discountImageURL" [src]="discountCoupon.discountImageURL" class="discountImage"></div>
      <div class="mat-cell"><span>Купон: </span><br /> <span class="discount">{{discountCoupon.couponName}}</span></div>
      <div class="mat-cell">Скидка в {{discountCoupon.couponSum}}$ ({{getAppropriateCouponSumValue(discountCoupon.couponSum) | number : '1.2-2'}}{{getUserCurrencySign()}})</div>
      <div class="mat-cell text-left discountDescription">{{discountCoupon.description}} {{discountCoupon.couponStartSum}}$ ({{getAppropriateCouponSumValue(discountCoupon.couponStartSum) | number : '1.2-2'}}{{getUserCurrencySign()}})</div>
      <div class="mat-cell text-right">{{getProperCertificateEndDate(discountCoupon.endDate)}}</div>
      <div class="mat-header-cell text-right"><mat-checkbox [checked]="discountCoupon.isSelected" (change)="handleDiscountCouponSelection(discountCoupon.id)" color="primary"></mat-checkbox></div>
    </div>
  </div>
</div>
